import { ethers } from 'ethers';
import { commons, universal } from '@0xsequence/core';

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/* eslint-disable */
// sequence-guard v0.4.0 a29651d1d5f63268e8d03b51e46557e0632c144d
// --
// Code generated by webrpc-gen@v0.10.x-dev with typescript generator. DO NOT EDIT.
//
// webrpc-gen -schema=guard.ridl -target=typescript -client -out=./clients/guard.gen.ts

// WebRPC description and code-gen version
const WebRPCVersion = "v1";

// Schema version of your RIDL schema
const WebRPCSchemaVersion = "v0.4.0";

// Schema hash generated from your RIDL schema
const WebRPCSchemaHash = "a29651d1d5f63268e8d03b51e46557e0632c144d";

//
// Types
//
//
// Client
//
class Guard {
  constructor(hostname, fetch) {
    this.path = '/rpc/Guard/';
    this.ping = headers => {
      return this.fetch(this.url('Ping'), createHTTPRequest({}, headers)).then(res => {
        return buildResponse(res).then(_data => {
          return {
            status: _data.status
          };
        });
      });
    };
    this.version = headers => {
      return this.fetch(this.url('Version'), createHTTPRequest({}, headers)).then(res => {
        return buildResponse(res).then(_data => {
          return {
            version: _data.version
          };
        });
      });
    };
    this.runtimeStatus = headers => {
      return this.fetch(this.url('RuntimeStatus'), createHTTPRequest({}, headers)).then(res => {
        return buildResponse(res).then(_data => {
          return {
            status: _data.status
          };
        });
      });
    };
    this.getSignerConfig = (args, headers) => {
      return this.fetch(this.url('GetSignerConfig'), createHTTPRequest(args, headers)).then(res => {
        return buildResponse(res).then(_data => {
          return {
            signerConfig: _data.signerConfig
          };
        });
      });
    };
    this.sign = (args, headers) => {
      return this.fetch(this.url('Sign'), createHTTPRequest(args, headers)).then(res => {
        return buildResponse(res).then(_data => {
          return {
            sig: _data.sig
          };
        });
      });
    };
    this.signWith = (args, headers) => {
      return this.fetch(this.url('SignWith'), createHTTPRequest(args, headers)).then(res => {
        return buildResponse(res).then(_data => {
          return {
            sig: _data.sig
          };
        });
      });
    };
    this.hostname = hostname;
    this.fetch = (input, init) => fetch(input, init);
  }
  url(name) {
    return this.hostname + this.path + name;
  }
}
const createHTTPRequest = (body = {}, headers = {}) => {
  return {
    method: 'POST',
    headers: _extends({}, headers, {
      'Content-Type': 'application/json'
    }),
    body: JSON.stringify(body || {})
  };
};
const buildResponse = res => {
  return res.text().then(text => {
    let data;
    try {
      data = JSON.parse(text);
    } catch (err) {
      throw {
        code: 'unknown',
        msg: `expecting JSON, got: ${text}`,
        status: res.status
      };
    }
    if (!res.ok) {
      throw data; // webrpc error response
    }

    return data;
  });
};

class GuardSigner {
  constructor(address, url, appendSuffix = false) {
    this.requests = new Map();
    this.address = address;
    this.url = url;
    this.appendSuffix = appendSuffix;
    this.guard = new Guard(url, global.fetch);
  }
  async getAddress() {
    return this.address;
  }
  async requestSignature(id, _message, metadata, callbacks) {
    if (!commons.isWalletSignRequestMetadata(metadata)) {
      callbacks.onRejection('Expected Sequence-like metadata');
    } else {
      // Queue the request first, this method only does that
      // the requesting to the API is later handled on every status change
      this.requests.set(id, callbacks);
    }
    return true;
  }
  notifyStatusChange(id, status, metadata) {
    if (!this.requests.has(id)) return;
    if (!commons.isWalletSignRequestMetadata(metadata)) {
      this.requests.get(id).onRejection('Expected Sequence-like metadata (status update)');
      return;
    }
    this.evaluateRequest(id, status.message, status, metadata);
  }
  packMsgAndSig(address, msg, sig, chainId) {
    return ethers.utils.defaultAbiCoder.encode(['address', 'uint256', 'bytes', 'bytes'], [address, chainId, msg, sig]);
  }
  keyOfRequest(signer, msg, auxData, chainId) {
    return ethers.utils.solidityKeccak256(['address', 'uint256', 'bytes', 'bytes'], [signer, chainId, msg, auxData]);
  }
  async evaluateRequest(id, message, _, metadata) {
    var _metadata$parts;
    // Building auxData, notice: this uses the old v1 format
    // TODO: We should update the guard API so we can pass the metadata directly
    const coder = universal.genericCoderFor(metadata.config.version);
    const {
      encoded
    } = coder.signature.encodeSigners(metadata.config, (_metadata$parts = metadata.parts) != null ? _metadata$parts : new Map(), [], metadata.chainId);
    try {
      var _this$requests$get;
      const key = this.keyOfRequest(this.address, message, encoded, metadata.chainId);
      const lastAttempt = (_this$requests$get = this.requests.get(id)) == null ? void 0 : _this$requests$get.lastAttempt;
      if (lastAttempt === key) {
        return;
      }
      this.requests.get(id).lastAttempt = key;
      const result = await this.guard.signWith({
        signer: this.address,
        request: {
          msg: ethers.utils.hexlify(message),
          auxData: this.packMsgAndSig(metadata.address, metadata.digest, encoded, metadata.chainId),
          chainId: ethers.BigNumber.from(metadata.chainId).toNumber() // TODO: This should be a string (in the API)
        }
      });

      if (ethers.utils.arrayify(result.sig).length !== 0) {
        this.requests.get(id).onSignature(result.sig);
        this.requests.delete(id);
      }
    } catch (e) {
      // The guard signer may reject the request for a number of reasons
      // like for example, if it's being the first signer (it waits for other signers to sign first)
      // for now we ignore all errors, but we should probably handle them
      // TODO: Filter real errors from control flow errors
    }
  }
  suffix() {
    return this.appendSuffix ? [3] : [];
  }
}

export { Guard, GuardSigner, WebRPCSchemaHash, WebRPCSchemaVersion, WebRPCVersion };
